<template>
    <el-card shadow="never" class="aui-card--fill">
        <div class="mod-ums__memberbalancecharge">
            <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
                <el-form-item v-if="visible">
                    <el-select v-model="dataForm.orgId" placeholder="请选择区域">
                        <el-option label="全选" value="" key=""></el-option>
                        <el-option
                                v-for="item in orgList"
                                :key="item.id"
                                :label="item.orgName"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="dataForm.mobileNumber" placeholder="会员电话" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="dataForm.memberName" placeholder="会员姓名" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <template>
                        <div class="block">
                            <el-date-picker
                                    v-model="dataForm.beginDate"
                                    type="date"
                                    :clearable="true"
                                    format="yyyy年MM月dd日"
                                    value-format="yyyy-MM-dd"
                                    placeholder="开始时间">
                            </el-date-picker>
                        </div>
                    </template>
                </el-form-item>
                <el-form-item>
                    <template>
                        <div class="block">
                            <el-date-picker
                                    v-model="dataForm.endDate"
                                    type="date"
                                    :clearable="true"
                                    format="yyyy年MM月dd日"
                                    value-format="yyyy-MM-dd"
                                    placeholder="结束时间">
                            </el-date-picker>
                        </div>
                    </template>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="dataForm.operatType" placeholder="操作类型">
                        <el-option
                                v-for="item in operatTypes"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button @click="getDataList()">{{ $t('query') }}</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
                </el-form-item>
                <!--        <el-form-item>-->
                <!--          <el-button v-if="$hasPermission('ums:memberbalancecharge:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>-->
                <!--        </el-form-item>-->
                <!--        <el-form-item>-->
                <!--          <el-button v-if="$hasPermission('ums:memberbalancecharge:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>-->
                <!--        </el-form-item>-->
            </el-form>
            <el-table v-loading="dataListLoading" :data="dataList" border
                      @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
                <!--        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>-->
                <el-table-column prop="orgName" label="公司名称" header-align="center" align="center"></el-table-column>
                <el-table-column prop="memberName" label="会员姓名" header-align="center" align="center"></el-table-column>
                <el-table-column prop="mobileNumber" label="会员电话号" header-align="center"
                                 align="center"></el-table-column>
                <el-table-column prop="changeNumber" label="改变数值" header-align="center"
                                 align="center"></el-table-column>
                <!--                <el-table-column prop="balance" label="余额" header-align="center" align="center"></el-table-column>-->
                <!--        <el-table-column prop="id" label="ID" header-align="center" align="center"></el-table-column>-->
                <!--        <el-table-column prop="memberId" label="会员ID" header-align="center" align="center"></el-table-column>-->
                <el-table-column prop="balanceType" label="账户类型" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.balanceType===1" type="success">现金</el-tag>
                        <el-tag v-else-if="scope.row.balanceType===2" type="success">普通优果</el-tag>
                        <el-tag v-else-if="scope.row.balanceType===3" type="success">乾坤袋</el-tag>
                        <el-tag v-else-if="scope.row.balanceType===4" type="success">祝福袋</el-tag>
                        <el-tag v-else-if="scope.row.balanceType===6" type="success">分红优果</el-tag>
                        <el-tag v-else-if="scope.row.balanceType===7" type="success">设备租金(存储)</el-tag>
                        <el-tag v-else-if="scope.row.balanceType===8" type="success">分红</el-tag>
                        <el-tag v-else-if="scope.row.balanceType===9" type="success">期权</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="operatType" label="操作类型" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.operatType===0" type="success">分享直推收益</el-tag>
                        <el-tag v-else-if="scope.row.operatType===1" type="success">分享间推收益</el-tag>
                        <el-tag v-else-if="scope.row.operatType===2" type="success">合伙人分享收益</el-tag>
                        <el-tag v-else-if="scope.row.operatType===3" type="success">合伙人区域每月服务费收益</el-tag>
                        <el-tag v-else-if="scope.row.operatType===4" type="success">合伙人区域奖金</el-tag>
                        <el-tag v-else-if="scope.row.operatType===5" type="success">合伙人个人市场奖金</el-tag>
                        <el-tag v-else-if="scope.row.operatType===6" type="success">合伙人区域优果返利</el-tag>
                        <el-tag v-else-if="scope.row.operatType===7" type="success">市场合伙人优果收益抽成</el-tag>
                        <el-tag v-else-if="scope.row.operatType===8" type="success">商品购买花费现金</el-tag>
                        <el-tag v-else-if="scope.row.operatType===9" type="success">商品购买花费优果</el-tag>
                        <el-tag v-else-if="scope.row.operatType===10" type="success">优果转账</el-tag>
                        <el-tag v-else-if="scope.row.operatType===11" type="success" size="small">卖家售卖优果</el-tag>
                        <el-tag v-else-if="scope.row.operatType===12" type="success" size="small">取消售卖</el-tag>
                        <el-tag v-else-if="scope.row.operatType===13" type="success" size="small">寄售申诉通过</el-tag>
                        <el-tag v-else-if="scope.row.operatType===14" type="success" size="small">寄售平台拒绝</el-tag>
                        <el-tag v-else-if="scope.row.operatType===15" type="success" size="small">买家购买优果</el-tag>
                        <el-tag v-else-if="scope.row.operatType===16" type="success" size="small">买家支付超时</el-tag>
                        <el-tag v-else-if="scope.row.operatType===17" type="success" size="small">设备续费</el-tag>
                        <el-tag v-else-if="scope.row.operatType===18" type="success" size="small">签到加优果</el-tag>
                        <el-tag v-else-if="scope.row.operatType===19" type="success" size="small">系统操作加现金</el-tag>
                        <el-tag v-else-if="scope.row.operatType===20" type="success" size="small">提现</el-tag>
                        <el-tag v-else-if="scope.row.operatType===23" type="success" size="small">清空设备优果</el-tag>
                        <el-tag v-else-if="scope.row.operatType===22" type="success" size="small">兑换奖品</el-tag>
                        <el-tag v-else-if="scope.row.operatType===21" type="success" size="small">提现失败返回</el-tag>
                        <el-tag v-else-if="scope.row.operatType===24" type="success" size="small">设备续费返利</el-tag>
                        <el-tag v-else-if="scope.row.operatType===25" type="success" size="small">订单退款</el-tag>
                        <el-tag v-else-if="scope.row.operatType===26" type="success" size="small">商城操作</el-tag>
                        <el-tag v-else-if="scope.row.operatType===27" type="success" size="small">商城撤销操作</el-tag>
                        <el-tag v-else-if="scope.row.operatType===28" type="success" size="small">分红</el-tag>
                        <el-tag v-else-if="scope.row.operatType===29" type="success" size="small">补偿专用时长</el-tag>
                        <el-tag v-else-if="scope.row.operatType===30" type="success" size="small">补偿设备续费</el-tag>
                        <el-tag v-else-if="scope.row.operatType===31" type="success" size="small">U2直推奖励</el-tag>
                        <el-tag v-else-if="scope.row.operatType===32" type="success" size="small">U2合伙人奖励</el-tag>
                        <el-tag v-else-if="scope.row.operatType===33" type="success" size="small">U2公司奖励</el-tag>
                        <el-tag v-else-if="scope.row.operatType===98" type="success" size="small">自动转期权</el-tag>
                        <el-tag v-else-if="scope.row.operatType===99" type="success" size="small">后台操作</el-tag>

                    </template>
                </el-table-column>
                <el-table-column prop="changeType" label="改变类型" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.changeType===1" type="success">增加</el-tag>
                        <el-tag v-else-if="scope.row.changeType===2" type="success">减少</el-tag>
                    </template>
                </el-table-column>
                <!--        <el-table-column prop="note" label="流水备注" header-align="center" align="center"></el-table-column>-->
                <!--        <el-table-column prop="orderId" label="订单编号" header-align="center" align="center"></el-table-column>-->
                <!--        <el-table-column prop="creator" label="创建者" header-align="center" align="center"></el-table-column>-->
                <!--        <el-table-column prop="deptId" label="部门ID" header-align="center" align="center"></el-table-column>-->
                <el-table-column prop="srcMemberName" label="来源用户" header-align="center" align="center"></el-table-column>
                <el-table-column prop="orderDate" label="订单支付时间" header-align="center" align="center"></el-table-column>
                <el-table-column prop="createDate" label="创建时间" header-align="center" align="center"></el-table-column>
                <!--        <el-table-column prop="updateDate" label="更新时间" header-align="center" align="center"></el-table-column>-->
                <!--        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">-->
                <!--          <template slot-scope="scope">-->
                <!--            <el-button v-if="$hasPermission('ums:memberbalancecharge:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>-->
                <!--            <el-button v-if="$hasPermission('ums:memberbalancecharge:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>-->
                <!--          </template>-->
                <!--                </el-table-column>-->
            </el-table>
            <el-pagination
                    :current-page="page"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="limit"
                    :total="total"
                    layout="total, sizes, prev, pager, next, jumper"
                    @size-change="pageSizeChangeHandle"
                    @current-change="pageCurrentChangeHandle">
            </el-pagination>
            <!-- 弹窗, 新增 / 修改 -->
            <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
        </div>
    </el-card>
</template>

<script>
    import mixinViewModule from '@/mixins/view-module'
    import AddOrUpdate from './memberbalancecharge-add-or-update'

    export default {
        mixins: [mixinViewModule],
        data() {
            return {
                visible: false,
                orgList: [],
                mixinViewModuleOptions: {
                    getDataListURL: '/ums/memberbalancecharge/page',
                    getDataListIsPage: true,
                    exportURL: '/ums/memberbalancecharge/export',
                    deleteURL: '/ums/memberbalancecharge',
                    deleteIsBatch: true,
                    activatedIsNeed: false
                },
                operatTypes: [{
                    value: '8',
                    label: '商品购买花费现金'
                }, {
                    value: '0',
                    label: '分享直推收益'
                }, {
                    value: '1',
                    label: '分享间推收益'
                }, {
                    value: '2',
                    label: '合伙人分享收益'
                }, {
                    value: '3',
                    label: '合伙人区域每月服务费收益'
                }, {
                    value: '4',
                    label: '合伙人区域奖金'
                }, {
                    value: '5',
                    label: '合伙人个人市场奖金'
                }, {
                    value: '20',
                    label: '提现'
                }, {
                    value: '21',
                    label: '提现失败返回'
                }, {
                    value: '19',
                    label: '系统操作加现金'
                }, {
                    value: '23',
                    label: '清空设备优果'
                }, {
                    value: '22',
                    label: '兑换奖品'
                }, {
                    value: '24',
                    label: '设备续费返利'
                }],
                dataForm: {
                    beginDate: "",
                    endDate: "",
                    mobileNumber: '',
                    balanceType: 1,
                    operatType: '',
                    memberName: '',
                    orgId: '',
                    orgName:'',
                    isHead:false
                }
            }
        },
        mounted() {
            const that = this;
            that.getInfo();
        },
        components: {
            AddOrUpdate
        },
        created() {
            let d = new Date
            d.setDate(d.getDate()-1);
            this.dataForm.beginDate=d
        },
        methods: {
            getInfo() {
                this.$http.get(`/sys/user/info`).then(({data: res}) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    this.dataForm.orgId=res.data.orgId
                    this.dataForm.orgName=res.data.orgName
                    this.dataForm.isHead=res.data.isHead;
                    if (this.dataForm.isHead) {
                        this.visible=true;
                        this.getOrgList();
                    }
                    if(!this.mixinViewModuleOptions.activatedIsNeed){
                        this.getDataList()
                    }
                }).catch(() => {
                })
            },
            // 获取部门列表
            getOrgList() {
                return this.$http.get('/sys/org/select').then(({data: res}) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    this.orgList = res.data
                }).catch(() => {
                })
            },
            // 转化时间格式
            dateFtt(fmt, date) {
                var o = {
                    "M+": date.getMonth() + 1, //月份
                    "d+": date.getDate(), //日
                    "h+": date.getHours(), //小时
                    "m+": date.getMinutes(), //分
                    "s+": date.getSeconds(), //秒
                    "q+": Math.floor((date.getMonth() + 3) / 3), //季度
                    S: date.getMilliseconds() //毫秒
                };
                if (/(y+)/.test(fmt))
                    fmt = fmt.replace(
                        RegExp.$1,
                        (date.getFullYear() + "").substr(4 - RegExp.$1.length)
                    );
                for (var k in o)
                    if (new RegExp("(" + k + ")").test(fmt))
                        fmt = fmt.replace(
                            RegExp.$1,
                            RegExp.$1.length == 1
                                ? o[k]
                                : ("00" + o[k]).substr(("" + o[k]).length)
                        );
                return fmt;
            },
            crtTimeFtt(value) {
                var crtTime = new Date(value);
                //直接调用公共JS里面的时间类处理的办法
                //yyyy-MM-dd hh:mm:ss
                return this.dateFtt("yyyy-MM-dd", crtTime);
            },
        }
    }
</script>
